import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserModel } from '@common/models/User.model';
import { HelpdeskSsoService } from '@common/services/helpdesk-sso.service';
import { sanitizeReturnUrl } from '@common/utils/uri';
import { currentUserSubject } from '../services/user.service';

@Injectable()
export class LoginGuard {
    private currentUser: UserModel;

    constructor(
        private router: Router,
        private helpdeskSsoService: HelpdeskSsoService
    ) {
        currentUserSubject.subscribe((user) => {
            this.currentUser = user;
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // status - no user available
        const status = !this.currentUser;

        if (!status) {
            const returnUrl = route.queryParams.returnUrl;
            if (this.helpdeskSsoService.isAuthorizeUrl(returnUrl)) {
                // already logged in: straight back to the helpdesk's authorize request. Refused
                // (e.g. while impersonating, the error is shown by the interceptor): to the start page.
                this.helpdeskSsoService.continueToHelpdesk(returnUrl).catch(() => this.router.navigate(['/']));
            } else if (returnUrl) {
                this.router.navigateByUrl(sanitizeReturnUrl(returnUrl));
            } else {
                this.router.navigate(['/']);
            }
        }

        return status;
    }
}
